var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"td-salon-car",style:(_vm.box)},[_c('div',{class:_vm.container},[(!!_vm.content)?_c('div',{staticClass:"editor-content",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }